import client from './axiosClient';
export const getAdminDashboard = () => client.get('/dashboard/admin');
export const getUserDashboard  = () => client.get('/dashboard/user');
